var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcoHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95833 11.25V14.4643C5.95833 14.76 5.71567 15 5.41667 15H0.541667C0.242667 15 0 14.76 0 14.4643V4.82152C0 4.65009 0.0828751 4.48884 0.223167 4.38813L6.1815 0.102454C6.37108 -0.0341515 6.62892 -0.0341515 6.8185 0.102454L12.7768 4.38813C12.9171 4.48884 13 4.65009 13 4.82152V14.4643C13 14.76 12.7573 15 12.4583 15H7.58333C7.28433 15 7.04167 14.76 7.04167 14.4643V11.25H5.95833ZM8.125 13.9286H11.9167V5.0942L6.5 1.19798L1.08333 5.0942V13.9286H4.875V10.7143C4.875 10.4186 5.11767 10.1786 5.41667 10.1786H7.58333C7.88233 10.1786 8.125 10.4186 8.125 10.7143V13.9286Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcoHome);
export default __webpack_public_path__ + "static/media/menu-ico_home.efa198e4da782230eaaac9d67bdfc3b0.svg";
export { ForwardRef as ReactComponent };